import Reveal from "react-reveal/Reveal";
import { useEmblaCarousel } from "embla-carousel/react";
import { useCallback } from "react";

import "./style.css";
import { Testimonial } from "./Testimonial";

export function Testimonials({ testimonials }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({ draggable: false });

  const scrollNext = useCallback(() => {
    if (emblaApi.canScrollNext()) emblaApi.scrollNext();
    else emblaApi.scrollTo(0);
  }, [emblaApi]);

  return (
    <Reveal>
      <div className="embla" ref={emblaRef}>
        <div className="embla__container">
          {testimonials.map((testimonial) => (
            <div className="embla__slide" key={testimonial.id}>
              <Testimonial
                testimonial={testimonial}
                position={testimonial.id}
                total={testimonials.length}
                onClickNext={scrollNext}
                showNext={true}
              />
            </div>
          ))}
        </div>
      </div>
    </Reveal>
  );
}